/* eslint-disable import/no-import-module-exports */
import React from 'react';
import { render } from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';
import App from './App';

smoothscroll.polyfill();

const target = document.querySelector('#root');

function renderApp(Component: React.ReactElement) {
  render(Component, target);
}

renderApp(App);

if (module && module.hot) {
  module.hot.accept('./App', () => {
    /* eslint "global-require": "off" */
    const DevRoutes = require('./App').default;

    renderApp(DevRoutes);
  });
}
